import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Toast } from 'primeng/toast';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  // private networkStatus = inject(NetworkStatusService);
  private translate = inject(TranslateService);

  // public isOnline = this.networkStatus.isOnline;
  // public isConnectionSlow = this.networkStatus.isSlow;

  constructor() {
    this.translate.addLangs(['en', 'bn']);
    this.translate.setDefaultLang('bn');
    this.translate.use('bn');
  }

  ngOnInit() {
    const language: boolean = this.translate.currentLang === 'bn';
    if (language) {
      document.body.classList.add('bangali');
    }
  }
}
